import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { safeHtml } from "../lib/sanitize";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function DealPage() {
  const { slug } = useParams();
  const [deal, setDeal] = useState(null);
  useEffect(() => { api.get(`/deals/slug/${slug}`).then((r) => setDeal(r.data)).catch(() => {}); }, [slug]);
  if (!deal) return (<div className="min-h-screen"><Header /><div className="container-page py-24">Loading…</div></div>);
  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Header />
      <article className="container-page py-12 md:py-16 max-w-4xl" data-testid="deal-page">
        <Link to="/deals" className="overline text-[#4A4742] hover:text-[#1B3B36]">← All deals</Link>
        <div className="overline text-[#B4533C] mt-6">Deal Alert · {deal.airline || "Multiple airlines"}</div>
        <h1 className="font-serif text-4xl md:text-6xl tracking-tight mt-3" data-testid="deal-title">{deal.title}</h1>
        {deal.featured_image && <div className="mt-8 aspect-[16/9] overflow-hidden border border-[#D6CFC4]"><img src={deal.featured_image} alt={deal.title} className="w-full h-full object-cover" /></div>}
        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 grid-borders border-t border-l border-[#D6CFC4]">
          <Cell k="From" v={deal.origin} />
          <Cell k="To" v={deal.destination} />
          <Cell k="Class" v={deal.cabin_class} />
          <Cell k="Cash" v={deal.cash_price ? `$${deal.cash_price}` : "—"} />
          <Cell k="Points" v={deal.points_price ? deal.points_price.toLocaleString() : "—"} />
          <Cell k="Taxes" v={deal.taxes_and_fees ? `$${deal.taxes_and_fees}` : "—"} />
          <Cell k="Airline" v={deal.airline || "—"} />
          <Cell k="Expires" v={deal.expires_at ? new Date(deal.expires_at).toLocaleDateString() : "Open"} />
        </div>
        <div className="prose-editorial mt-10" dangerouslySetInnerHTML={safeHtml(deal.body_rich_text)} />
        {deal.booking_url && (
          <a href={deal.booking_url} target="_blank" rel="sponsored noopener noreferrer" className="inline-block mt-8 bg-[#1B3B36] text-white px-8 py-4 tracking-wide hover:bg-[#112622]" data-testid="deal-booking-cta">
            Book this deal →
          </a>
        )}
      </article>
      <Footer />
    </div>
  );
}

function Cell({ k, v }) {
  return (
    <div className="p-4">
      <div className="overline text-[#4A4742]">{k}</div>
      <div className="font-mono text-sm mt-1">{v}</div>
    </div>
  );
}
